import React from "react";
import "./Privacy.css";

const Privacy = () => {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>

      <section>
        <h2>1. Introduction</h2>
        <p>
          This Privacy Policy outlines how OurCountryOurPeople Foundation collects, uses, and protects
          your personal information when you use our website. By accessing our
          website, you agree to the terms outlined in this policy.
        </p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <ul>
          <li>
            <strong>Personal Information:</strong> We may collect personal
            information, including but not limited to your name, email address,
            phone number, and postal address when you voluntarily provide it,
            such as when making a donation.
          </li>
          <li>
            <strong>Non-Personal Information:</strong> We may also collect
            non-personal information, such as browser type, operating system,
            and IP address, for analytical purposes.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. How We Use Your Information</h2>
        <ul>
          <li>
            <strong>Donations:</strong> Personal information collected during
            donations is used to process transactions and provide
            donation-related communications.
          </li>
          <li>
            <strong>Communication:</strong> We may use your contact information
            to send newsletters, updates, or respond to inquiries.
          </li>
          <li>
            <strong>Analytics:</strong> Non-personal information may be used for
            statistical analysis and website improvement.
          </li>
        </ul>
      </section>

      <section>
        <h2>4. Cookies</h2>
        <p>
          Our website may use cookies to enhance user experience. You can modify
          your browser settings to reject cookies, but this may impact website
          functionality.
        </p>
      </section>

      <section>
        <h2>5. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites. We are not
          responsible for their privacy practices, and you should review their
          policies independently.
        </p>
      </section>

      <section>
        <h2>6. Data Security</h2>
        <p>
          We implement reasonable security measures to protect your information.
          However, no method of transmission over the internet is entirely
          secure.
        </p>
      </section>

      <section>
        <h2>7. Access to Your Information</h2>
        <p>
          You have the right to access, update, or delete your personal
          information. Contact us at{" "}
          <a href="mailto:namnadunammakkall@gmail.com">
            namnadunammakkall@gmail.com
          </a>{" "}
          or +91 9840693733 for assistance.
        </p>
      </section>

      <section>
        <h2>8. Changes to this Privacy Policy</h2>
        <p>
          We reserve the right to update this Privacy Policy. Any changes will be
          posted on this page.
        </p>
      </section>

      <section>
        <h2>9. Governing Law</h2>
        <p>This Privacy Policy is governed by the laws of India.</p>
      </section>

      <section>
        <h2>10. Contact Information</h2>
        <p>
          If you have questions about this Privacy Policy, please contact us at{" "}
          <a href="mailto:namnadunammakkall@gmail.com">
            namnadunammakkall@gmail.com
          </a>{" "}
          or +91 9840693733.
        </p>
      </section>
    </div>
  );
};

export default Privacy;
